import React, { useEffect } from "react"
import { AppIconChipToggle } from "@components"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"


export default function SwitchCSV() {

	useEffect(() => {
		useCsv.value = !!reportFormData.peek().customConfigData?.length
	}, [])

	return <AppIconChipToggle
		aria-label="Searches from"
		value={!!useCsv.value}
		options={[
			{ value: false, label: 'Date setup', icon: 'calendar-days' },
			{ value: true, label: 'CSV file', icon: 'file-csv' },
		]}
		onChange={value => useCsv.value = value}
	/>
}